import { Link } from "react-router-dom";
import { NAV, SITE } from "@/data/content";
import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-forest text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <img src="/brand/logo-white.png" alt="Amaya Pro" className="h-8 w-auto mb-5" />
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              A complete Network Lighting Control ecosystem — connecting luminaires, sensors and controls through secure Bluetooth Mesh.
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono text-xs text-leaf uppercase tracking-widest mb-4">Site</p>
            <ul className="space-y-2.5">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-sm text-white/80 hover:text-leaf transition-colors">{n.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-xs text-leaf uppercase tracking-widest mb-4">Actions</p>
            <ul className="space-y-2.5">
              <li><Link to="/contact?type=demo" className="text-sm text-white/80 hover:text-leaf transition-colors flex items-center gap-1">Request a Demo <ArrowUpRight size={13} /></Link></li>
              <li><Link to="/contact?type=quote" className="text-sm text-white/80 hover:text-leaf transition-colors flex items-center gap-1">Get a Quote <ArrowUpRight size={13} /></Link></li>
              <li><Link to="/resources" className="text-sm text-white/80 hover:text-leaf transition-colors flex items-center gap-1">Specifications & Resources <ArrowUpRight size={13} /></Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-xs text-leaf uppercase tracking-widest mb-4">Contact</p>
            <ul className="space-y-2.5 text-sm text-white/80">
              <li><a href={`tel:${SITE.phone}`} className="hover:text-leaf transition-colors" data-testid="footer-phone">{SITE.phone}</a></li>
              <li><a href={`mailto:${SITE.email}`} className="hover:text-leaf transition-colors" data-testid="footer-email">{SITE.email}</a></li>
              <li className="text-white/60">{SITE.address}</li>
              <li className="text-white/40 text-xs pt-2">Technical support: {SITE.supportPhone}</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-white/15 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Amaya Pro. All rights reserved.</p>
          <div className="flex gap-6">
            <span className="text-white/35">Privacy Policy — coming soon</span>
            <span className="text-white/35">Terms — coming soon</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
